import { create } from 'zustand';
import { DEFAULT_THEME, themes, type ThemeId } from '@/themes/manifest';

const STORAGE_KEY = 'hmhapps:theme';

function readInitial(): ThemeId {
  if (typeof document === 'undefined') return DEFAULT_THEME;
  const attr = document.documentElement.getAttribute('data-theme') as ThemeId | null;
  if (attr && themes.some((t) => t.id === attr)) return attr;
  return DEFAULT_THEME;
}

type ThemeStore = {
  theme: ThemeId;
  setTheme: (id: ThemeId) => void;
};

export const useThemeStore = create<ThemeStore>((set) => ({
  theme: readInitial(),
  setTheme: (id) => {
    document.documentElement.setAttribute('data-theme', id);
    try { localStorage.setItem(STORAGE_KEY, id); } catch { /* quota or private mode — accept silently */ }
    set({ theme: id });
  },
}));
